import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import RecentUnreadMessagesWidget from "../Presentational/Widgets/RecentUnreadMessagesWidget";
import MessageService from "../../Services/Message.service";
import useService from "../Hooks/useService";
const RecentUnreadMessagesContainer = () => {
    const [messagesState, loadMessages] = useService(MessageService.getAdvisorUnreadMessages);
    React.useEffect(() => {
        loadMessages();
    }, [loadMessages]);
    return (_jsx(RecentUnreadMessagesWidget, { messageState: messagesState, refresh: () => {
            loadMessages();
        } }));
};
export default RecentUnreadMessagesContainer;
